// extracted by mini-css-extract-plugin
module.exports = {"images":"Images_images__hOYCs","carouselPrevBtn":"Images_carouselPrevBtn__1nsLm","carouselNextBtn":"Images_carouselNextBtn__Ron_O"};